import template from '../../../../common/ui/progressBar/progressBar.html';
import { StatusProgressBarController as controller } from './progressBar.controller';

export default {
  restrict: 'E',
  bindings: {
    states: '<',
    activeState: '<',
    onStateChange: '&',
  },
  template,
  controller,
  controllerAs: 'vm',
};



// WEBPACK FOOTER //
// ./src/app/components/status/components/progressBar/progressBar.component.js